<template>
  <!-- اسلایدر اخبار مخصوص کشتی — بالای تب‌های فرنگی/آزاد -->
  <section v-if="news.length" class="wrestling-news-slider" dir="rtl" aria-label="اخبار کشتی">
    <div class="slider-header">
      <h2 class="slider-title">
        <span class="slider-icon" aria-hidden="true">🤼‍♂️</span>
        <span>اخبار کشتی</span>
        <span class="slider-sub">قرعه، پهلوانان ایرانی و مسیر رسیدن تا فینال</span>
      </h2>
      <div class="slider-nav">
        <button class="nav-btn" type="button" aria-label="خبر بعدی" @click="scrollByCard(1)">‹</button>
        <button class="nav-btn" type="button" aria-label="خبر قبلی" @click="scrollByCard(-1)">›</button>
      </div>
    </div>

    <div ref="track" class="slider-track" @mouseenter="pause" @mouseleave="resume">
      <router-link
          v-for="(item, i) in news"
          :key="item.id"
          class="news-card"
          :to="newsUrl(item)"
          :aria-label="item.title"
      >
        <div class="card-image">
          <img v-if="item.imageUrl" :src="item.imageUrl" :alt="item.title" loading="lazy">
          <div v-else class="card-image-fallback" aria-hidden="true">🤼</div>
          <span class="card-index" aria-hidden="true">{{ (i + 1).toLocaleString('fa-IR') }}</span>
        </div>
        <div class="card-body">
          <h3 class="card-title">{{ item.title }}</h3>
          <div class="card-meta">
            <span v-if="item.source && item.source.name" class="card-source">
              <span class="source-dot" aria-hidden="true"></span>{{ item.source.name }}
            </span>
            <span class="card-time">{{ timeAgo(item.publishedAt) }}</span>
          </div>
        </div>
      </router-link>
    </div>
  </section>
</template>

<script>
import api from '@/services/api';

const WRESTLING_KEYWORD = 'کشتی';
const FETCH_LIMIT = 10;

export default {
  name: 'WrestlingNewsSlider',
  data() {
    return {
      news: [],
      timer: null,
    };
  },
  async mounted() {
    await this.loadWrestlingNews();
    if (this.news.length) this.resume();
  },
  beforeDestroy() {
    this.stop();
  },
  methods: {
    async loadWrestlingNews() {
      try {
        const res = await api.request(`/news?search=${encodeURIComponent(WRESTLING_KEYWORD)}&limit=${FETCH_LIMIT}`);
        const items = (res && res.news) || [];
        // فقط خبرهای واقعی کشتی — تصویر یا عنوان باید معتبر باشد
        this.news = items.filter(n => n && n.title).slice(0, 8);
      } catch (e) {
        // اسلایدر غیرحیاتی است — در خطا کلاً مخفی می‌ماند
        this.news = [];
      }
    },
    newsUrl(item) {
      return '/news/' + item.id + '-' + this.slugify(item.title);
    },
    slugify(title) {
      if (!title) return '';
      return title
          .trim()
          .replace(/\u200c|\u200b|\u200d|\ufeff/g, '-')
          .replace(/[,;:.!?"'()]/g, '')
          .replace(/\s+/g, '-')
          .replace(/-+/g, '-')
          .replace(/^-|-$/g, '');
    },
    timeAgo(dateStr) {
      if (!dateStr) return '';
      const d = new Date(dateStr);
      if (isNaN(d.getTime())) return '';
      const diff = Math.floor((Date.now() - d.getTime()) / 1000);
      if (diff < 60) return 'لحظاتی پیش';
      if (diff < 3600) return `${(diff / 60).toLocaleString('fa-IR', { maximumFractionDigits: 0 })} دقیقه پیش`;
      if (diff < 86400) return `${(diff / 3600).toLocaleString('fa-IR', { maximumFractionDigits: 0 })} ساعت پیش`;
      if (diff < 604800) return `${(diff / 86400).toLocaleString('fa-IR', { maximumFractionDigits: 0 })} روز پیش`;
      try { return d.toLocaleDateString('fa-IR'); } catch (e) { return ''; }
    },
    scrollByCard(dir) {
      const track = this.$refs.track;
      if (!track) return;
      // در RTL اسکرول به سمت خبر بعدی یعنی left منفی
      const step = Math.max(track.clientWidth * 0.8, 260);
      track.scrollBy({ left: dir * -step, behavior: 'smooth' });
    },
    resume() {
      this.pause();
      this.timer = setInterval(() => {
        const track = this.$refs.track;
        if (!track) return this.pause();
        const maxScroll = track.scrollWidth - track.clientWidth;
        const atEnd = Math.abs(Math.abs(track.scrollLeft) - maxScroll) < 12;
        if (atEnd) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          this.scrollByCard(1);
        }
      }, 6000);
    },
    pause() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    stop() {
      this.pause();
    },
  },
};
</script>

<style scoped lang="scss">
.wrestling-news-slider {
  margin: 0 0 18px;
  padding: 14px 18px;
  background: linear-gradient(135deg, #0e3b2e 0%, #14523f 70%, #1a6a50 100%);
  border-radius: 14px;
  box-shadow: 0 6px 20px rgba(14, 59, 46, 0.18);
}

.slider-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}

.slider-title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  color: #fff;
  font-size: 17px;
  font-weight: 800;

  .slider-icon {
    font-size: 20px;
  }

  .slider-sub {
    font-size: 11.5px;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.72);

    @media (max-width: 640px) {
      display: none;
    }
  }
}

.slider-nav {
  display: flex;
  gap: 6px;
}

.nav-btn {
  width: 30px;
  height: 30px;
  border: 1px solid rgba(255, 255, 255, 0.35);
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
  transition: background 0.2s ease, transform 0.15s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.25);
    transform: scale(1.06);
  }

  &:active {
    transform: scale(0.96);
  }
}

.slider-track {
  display: flex;
  gap: 12px;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }
}

.news-card {
  flex: 0 0 240px;
  scroll-snap-align: start;
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  text-decoration: none;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.14);
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 8px 22px rgba(0, 0, 0, 0.22);

    .card-title {
      color: #1a6a50;
    }
  }
}

.card-image {
  position: relative;
  height: 128px;
  background: #e8efe9;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  .card-image-fallback {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 40px;
    background: linear-gradient(135deg, #d9e8df, #b8d4c5);
  }

  .card-index {
    position: absolute;
    top: 8px;
    right: 8px;
    min-width: 24px;
    height: 24px;
    padding: 0 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 12px;
    background: rgba(14, 59, 46, 0.85);
    color: #fff;
    font-size: 12px;
    font-weight: 700;
  }
}

.card-body {
  padding: 10px 12px 12px;
}

.card-title {
  margin: 0 0 8px;
  color: #163028;
  font-size: 13.5px;
  font-weight: 700;
  line-height: 1.65;
  height: 44px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  transition: color 0.2s ease;
}

.card-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.card-source {
  display: flex;
  align-items: center;
  gap: 5px;
  color: #6b7f77;
  font-size: 11px;

  .source-dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #1a6a50;
  }
}

.card-time {
  color: #94a39c;
  font-size: 10.5px;
  white-space: nowrap;
}

@media (max-width: 640px) {
  .wrestling-news-slider {
    padding: 12px 12px;
    border-radius: 12px;
  }

  .news-card {
    flex-basis: 200px;
  }

  .card-image {
    height: 108px;
  }
}
</style>
